import { SkitterbookLivePagesRequest, Rotation } from '../Models/SkitterbookLivePagesRequest';
import { SkitterBookImageMargin } from './SkitterBookImageMargin';
import { SkitterBookCoverPage } from './SkitterBookCoverPage';
import { SkitterBookImageCropper } from './SkitterBookImageCropper';
import { DockPanelHandle } from '../Controls/DockPanel/DockPanel';
import { ScrollDetacher } from '../Controls/ScrollDetacher';
import SkitterBookLiveSimulator from '../Simulators/SkitterBookLiveSimulator';
import './css/SkitterbookProperties.css';
import { SkitterBookRotation } from './SkitterBookRotation';

interface SkitterBookPropertiesProps {
    livePagesRequest?: SkitterbookLivePagesRequest | null;
    title: string;
    dockPanel: React.RefObject<DockPanelHandle | null>;
    onChange?: (newRequest: SkitterbookLivePagesRequest) => void;
}

export const SkitterBookProperties: React.FC<SkitterBookPropertiesProps> = ({ livePagesRequest, title, dockPanel, onChange }) => {
    return (
        <div className='skitterbook-properties-container'>
            {livePagesRequest &&

                <div className='skitterbook-properties-inner-container'>
                    <div className="skitterbook-properties-title">
                        <span>{title}</span>
                    </div>
                    <div className="skitterbook-live-simulator settle-effect">
                        <ScrollDetacher id="simulator-scroll-detacher"
                            dockPanel={dockPanel}
                            placeholder={<div></div>}
                            alternativeContent={<SkitterBookLiveSimulator useFlipVibration={true} imageMarginMm={livePagesRequest.ImageMarginMm} />} >
                            <SkitterBookLiveSimulator useFlipVibration={true} imageMarginMm={livePagesRequest.ImageMarginMm} />
                        </ScrollDetacher>
                    </div>
                    <div className="skitterbook-property-region settle-effect">
                        <div className="skitterbook-crop-image-container">
                            <span className="property-region-title">What portion of the video clip do you want to see on your Skitterbook?</span>
                            {
                                livePagesRequest && livePagesRequest.Frames && livePagesRequest.Frames.length > 0 &&
                                <SkitterBookImageCropper
                                    cropImage={livePagesRequest.Frames[Math.floor(livePagesRequest.Frames.length / 2)]}
                                    cropPosX={livePagesRequest.Viewport.x}
                                    cropPosY={livePagesRequest.Viewport.y}
                                    cropWidth={livePagesRequest.Viewport.width}
                                    cropHeight={livePagesRequest.Viewport.height}
                                    requiredRotation={livePagesRequest.Rotation}
                                    refresh={livePagesRequest}
                                    onCropChange={() => { }}
                                    onCropChangeEnd={(val) => {
                                        const newViewport = ({
                                            ...livePagesRequest.Viewport,
                                            x: val.x,
                                            y: val.y
                                        });

                                        const newLivePagesRequest = ({
                                            ...livePagesRequest,
                                            Viewport: newViewport,
                                            Rotation: livePagesRequest.Rotation
                                        })

                                        onChange?.(newLivePagesRequest);
                                    }}>
                                </SkitterBookImageCropper>
                            }
                        </div>
                    </div>

                    <div className="skitterbook-property-region settle-effect">
                        <span className="property-region-title">How should the image be oriented on the pages?</span>
                        {
                            livePagesRequest &&
                            <SkitterBookRotation value={livePagesRequest.Rotation}
                                onChange={(newValue: Rotation) => {
                                    const resetViewportPositions = ({
                                        ...livePagesRequest.Viewport,
                                        x: 0,
                                        y: 0
                                    })

                                    const newLivePagesRequest = ({
                                        ...livePagesRequest,
                                        Rotation: newValue,
                                        Viewport: resetViewportPositions
                                    })

                                    onChange?.(newLivePagesRequest);
                                }} />
                        }
                    </div>

                    <div className="skitterbook-property-region settle-effect">
                        <span className="property-region-title">How much margin should there be around each page image?</span>
                        <SkitterBookImageMargin imageMarginMm={livePagesRequest.ImageMarginMm}
                            onChange={(val: number) => {
                                const newLivePagesRequest = ({
                                    ...livePagesRequest,
                                    ImageMarginMm: val
                                })
                                onChange?.(newLivePagesRequest);
                            }} />
                    </div>

                    <div className="skitterbook-property-region settle-effect">
                        <span className="property-region-title">How would you like to style your cover page?</span>
                        <SkitterBookCoverPage isEnabled={true}
                            data={livePagesRequest.TitlePage}
                            frames={livePagesRequest.Frames}
                            onChanged={(val) => {
                                const newLivePagesRequest = ({
                                    ...livePagesRequest,
                                    TitlePage: val
                                })
                                onChange?.(newLivePagesRequest);
                            }} />
                    </div>
                </div>
            }
        </div>
    );
};
